export const enum LoginFormErrors {
	EMAIL_REQUIRED = 'email.required',
	EMAIL_INVALID = 'email.invalid',
	PASSWORD_REQUIRED = 'password.required'
}

export const enum RegistrationFormErrors {
	EMAIL_REQUIRED = 'email.required',
	EMAIL_INVALID = 'email.invalid',
	PASSWORD_REQUIRED = 'password.required',
	PASSWORD_MIN_LENGTH = 'password.minLength',
	PASSWORD_MATCHES = 'password.matches'
}
